import styled from 'styled-components'
import { Cancel, CheckCircle } from '@material-ui/icons'
import { StyledExternalLink, colors, theme } from '../../../../../theme/Global'

export const CenterText = styled.div`
  color: ${theme.colors.text};
  text-align: center;
`

export const StyledGreenIcon = styled(CheckCircle)`
    color: ${colors.green};
    display: inline-block;
    margin: 20px auto;
`

export const StyledRedIcon = styled(Cancel)`
    color: ${colors.govDocsRed};
    display: inline-block;
    margin: 20px auto;
`

export const CustomLink = styled(StyledExternalLink)`
  font-size: 12px;
`
